export default __webpack_public_path__ + "static/do-meaning-image-926656196a871c8512ccf54a94a17784.png";